import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasNodeToolOpened.meta';

export type UseTrackCanvasNodeToolOpenedParams = {
  canvas_id: string;
  node_type: 'image' | 'video';
  action_taken:
    | 'adjust_image'
    | 'camera_angle'
    | 'camera_motion'
    | 'change_lighting'
    | 'smart_resize'
    | 'crop'
    | 'prompt'
    | 'edit_text'
    | 'flip_and_rotate'
    | 'erase'
    | 'extend_background'
    | 'remove_background'
    | 'upscale'
    | 'convert_to_gif'
    | 'animate'
    | 'extend_video'
    | 'vectorize'
    | 'translate'
    | 'split_elements'
    | 'add_border'
    | 'add_text'
    | 'combine_images'
    | 'download'
    | 'merge_layers'
    | 'save_as_version'
    | 'save_to_board'
    | 'add_solid_background'
    | 'stylize';
  location: 'toolbar' | 'tools_menu' | 'empty_state' | 'tool_rail' | 'next_action_pill';
  rail_index?: number;
};

export const useTrackCanvasNodeToolOpened = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasNodeToolOpened = useCallback(
    (params: UseTrackCanvasNodeToolOpenedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasNodeToolOpened };
};
